import React from "react";
import CreativeCommonsIcon from "./common/CreativeCommonsIcon";
import { STANDARD_PHOTO_PRICE, PREMIUM_PHOTO_PRICE } from "core/constants";

// constants
export const NAME_BASIC = "Comp Download";
export const NAME_STANDARD = "Standard Royalty-Free";
export const NAME_PREMIUM = "Premium Royalty-Free";

// These are photo purchase types not resolution
// server download resolutions can be found:
// PhotoDownloadType :: static/assets/js/graphql/index.js
export const KEY_PUBLIC = "PUBLIC";
export const KEY_BASIC = "BASIC";
export const KEY_STANDARD = "STANDARD_PHOTO";
export const KEY_PREMIUM = "PREMIUM_PHOTO";

export const QUERY_OPTIONS = "options";
export const QUERY_PURCHASED = "purchase";

export const getBackendKey = name => {
    switch (name) {
        case NAME_BASIC:
            return KEY_BASIC;
        case NAME_STANDARD:
            return KEY_STANDARD;
        case NAME_PREMIUM:
            return KEY_PREMIUM;
        default:
            return null;
    }
};

export const getPrice = nameOrKey => {
    switch (nameOrKey) {
        case KEY_STANDARD:
        case NAME_STANDARD:
            return STANDARD_PHOTO_PRICE;
        case KEY_PREMIUM:
        case NAME_PREMIUM:
            return PREMIUM_PHOTO_PRICE;
        case KEY_BASIC:
        case NAME_BASIC:
            return "0";
    }
    return null;
};

export const getLicenseSchema = (name, { photo, selected, setSelected }) => {
    const dimensions = getDimensionProps(name, photo);
    const key = getBackendKey(name);
    const safeName = key.toLowerCase().replace(/[^a-z]/g, "");
    const mp = getMegapixels(dimensions);

    const icon = name === NAME_BASIC ? <CreativeCommonsIcon /> : null;

    return {
        id: `radio-${safeName}`,
        backendKey: key,
        title: name,
        ariaLabel: name,
        selected: key === selected,
        price: "$" + getPrice(name),
        optionName: mp,
        onClick: () => setSelected(key),
        attributionDisclaimer: "Must attribute artist. No edits.",
        meta: {
            mp,
            pixelDimensions: getPixelDimensions(dimensions),
            printDimensions: getPrintDimensions(dimensions),
            dpi: getDpi(dimensions)
        },
        link: (
            <>
                {name === NAME_BASIC && `Must attribute artist, no edits per `}
                <a href="/legal/terms-of-use/#photo-licenses" target="_blank">
                    license
                </a>
            </>
        ),
        icon: icon
    };
};

const getDimensionProps = (name, photo) => {
    switch (name) {
        case NAME_STANDARD:
        case NAME_PREMIUM:
            return photo.fullDimensions;
        case NAME_BASIC:
            return photo.freeDimensions;
    }
};

const getMegapixels = dimensions => {
    if (dimensions && dimensions.pixelWidth && dimensions.pixelHeight) {
        const raw = (dimensions.pixelWidth * dimensions.pixelHeight) / 1000000;
        const mp =
            raw < 1
                ? `.${Math.round(raw * 10)}`
                : raw > 9
                ? "10+"
                : Math.round(raw); // .2 MP, 5 MP, 10+ MP
        return `${mp} MP`;
    }
    return null;
};

const getPixelDimensions = dimensions => {
    if (dimensions && dimensions.pixelWidth && dimensions.pixelHeight) {
        return `${dimensions.pixelWidth}x${dimensions.pixelHeight} px`;
    }
    return null;
};

const getPrintDimensions = dimensions => {
    if (dimensions && dimensions.printWidth && dimensions.printHeight) {
        return `${dimensions.printWidth}"x${dimensions.printHeight}"`;
    }
    return null;
};

const getDpi = dimensions => {
    if (dimensions && dimensions.printDpi) {
        return `${dimensions.printDpi} dpi`;
    }
    return null;
};
